'use strict';

import $ from 'jquery';
import doT from 'dot';

import lxWrap from '../../common/js/lx'
import lxBid from '../../common/js/lx-bid'

import userCard from '../../tpl/user-card.html.js';
import msgList from '../../tpl/message-list.html.js'
import userCenter from '../../tpl/user-center.html.js'

/**
 * 
 * @param {node} trigger 触发节点
 * @param {node} target  目标节点
 * @param {function} setPos  位置回调函数
 */
function hoverShow(trigger, target, setPos, direction = 'left', activeClass = 'current', hideClass = 'Hide') {
    if (trigger.length > 0) {
        setPos = setPos || function (trigger, target) {
            let pos = trigger.offset(),
                topBorderWidth = parseInt(target.css('border-top-width')),
                width = trigger.outerWidth() - 2 * topBorderWidth;
            if (direction === 'right') {

                target.css({
                    top: pos.top + trigger.outerHeight() + 7 * topBorderWidth
                });

            } else {

                if (target && target.hasClass('J-user-target')) {

                    target.css({
                        left: pos.left
                    });

                } else if (target && target.hasClass('J-shop-serve-target')) {
                    target.css({
                        top: pos.top + trigger.outerHeight() + 6 * topBorderWidth,
                        left: pos.left,
                        width: width + 10
                    });
                }else {
                    target.css({
                        top: pos.top + trigger.outerHeight() + 6 * topBorderWidth,
                        left: pos.left,
                        width: width
                    });
                }

            }

        };
        [trigger, target].forEach(function (item) {

            item.on('mouseenter', function (e) {

                setPos(trigger, target);
                target.removeClass(hideClass);
                trigger.addClass(activeClass);
                e.stopPropagation();
                
                // 网站导航曝光打点
                lxWrap($('.J-site-target'), lxBid.siteNavViewBid, false, true)
                // if (target.hasClass('current')){
                //     lxWrap($('.J-site-target'), lxBid.siteNavViewBid, false, true)
                // }
            }).on('mouseleave', function (e) {

                target.addClass(hideClass);
                trigger.removeClass(activeClass);
                e.stopPropagation();

            });

        });
    }
}

const loginHanler = (container, config) => {
    // let loginTpl = $('<span class="userinfo-container"></span>')
    let userInfoTpl = $(`<span class="userinfo-container"><a target="_blank" href="${config.domain}/member/${config.userId}"  class="item left-split username J-user-trigger"><i class="icon i-arrow"></i></a>
                            <span class="seprate">|</span>
                       <a target="_blank" href="${config.domain}/msg/private" class="item left-split user-msg J-message-trigger">消息</a></span>`)
    // loginTpl[0].innerHTML = userInfoTpl
    let loginContainer = container.find('.J-login-container');
    userInfoTpl.find('.J-user-trigger').html(config.userName)
    userInfoTpl.insertAfter(loginContainer);
    loginContainer.remove();
}

/**
 * 加载用户信息
 * @param {*} config 
 */
function loadUserInfo(config) {

    let container = config.container;

    // 用户名片数据
    $.ajax({
        type: 'get',
        async: false,
        url: config.domain + '/member/jsonp/userCarteData',
        data: {
            memberId: config.userId
        },
        dataType: 'jsonp',
        success: function (result) {

            if (result.length && result[0]) {
                result = result[0];
            }
            if (result.code == 200) {

                result = result.msg.userCarte;

                let tempFn = doT.template(userCard);
                let resultText = tempFn({
                    avatar: result.userFace,
                    nickName: result.userNickName,
                    userId: result.userId,
                    reviewCount: result.reviewCount,
                    noteCount: result.noteCount,
                    fansCount: result.fansCount,
                    rank: result.userPower,
                    score: result.manaScore,
                    domain: config.domain
                });
                container.find('.J-user-target').remove();
                $(resultText).appendTo(container.find('.top-nav-container'));

                hoverShow(container.find('.J-user-trigger'), container.find('.J-user-target'));

            } else {
                console.log('用户名片数据请求失败')
            }

        },
        error: function () {

            console.log('用户名片数据请求失败')

        }
    });

    // 用户消息数据
    $.ajax({
        type: 'get',
        async: false,
        url: config.domain + '/member/jsonp/unreadMsg',
        data: {
            rand: Math.random() * 1000
        },
        dataType: 'jsonp',
        success: function (result) {

            if (result.length && result[0]) {

                result = result[0];

            }

            let data,
                temp = [],
                i, l,
                item,
                total = 0;

            if (result.code == 200) {

                data = result.msg.mc || [];

                for (i = 0, l = data.length; i < l; i++) {

                    item = data[i];
                    item.text = item.text.replace(/^[\u4e00-\u9fa5]\u65B0/, '');
                    temp.push(item);
                    total += item.count;

                }
                data = temp;

                // 有消息信息
                if (total) {

                    $('<span class="count">' + total + '</span>').appendTo(container.find('.J-message-trigger'));
                    let tempFn = doT.template(msgList);
                    let resultText = tempFn(data);
                    $(resultText).appendTo(container);

                    hoverShow(container.find('.J-message-trigger'), container.find('.J-message-target'));
                    
                    // 忽略消息
                    
                    container.on('click', '.J-ignore', function () {
                        $.ajax({
                            url: config.domain + '/member/jsonp/ignoreMsg',
                            data: {
                                // type: 1,
                                rand: (Math.random() * 1000)
                            },
                            dataType: 'jsonp',
                            success: function (res) {
                                if (res && res.code == 200){
                                    
                                    container.find('.J-message-target').remove();
                                    container.find('.J-message-trigger').removeClass('current');
                                    container.find('.J-message-trigger .count').remove();
                                    container.find('.J-message-trigger').off();
                                    console.log('用户消息清除成功')
                                }
                            },
                            error: function (e) {
                                console.log(`用户消息清除失败${e.responseText}`)
                            }
                        })

                    });

                }

            }

        },
        error: function () {
            console.log('用户消息数据请求失败')

        }
    });

}

function dealLogin(config, hideClass = 'Hide') {

    // 个人名片浮层
    let container = config.wrapper,
        loginContainer = container.find('.login-container'),
        userContainer = container.find('.userinfo-container');

    userContainer.removeClass(hideClass);
    loginContainer.addClass(hideClass);
    loadUserInfo({
        container: container,
        isLogin: config.isLogin,
        userId: config.userId,
        domain: config.domain || ''
    });
}


function showUserCenter(config, container) {
    let tempFn = doT.template(userCenter);
    let resultText = tempFn(config);
    $(resultText).appendTo(container.find('.J-my-center-target'));
}
/**
 * 非首页显示 点评首页
 * @param {*} config 
 * @param {*} container 
 * @param {*} hideClass 
 */
function showMiniLogo(config, container, hideClass = 'Hide') {

    if (!config.isIndexPage) {
        container.find('.mini-logo').removeClass(hideClass);
    }

}


export default {
    init: function (config) {
        let container = config.wrapper.find('.top-nav-container');

        // 判断是否首页
        showMiniLogo(config, container)

        // 个人中心展示
        showUserCenter(config, container)

        // 如果用户登录,加载用户信息
        if (config.isLogin === true) {

            loginHanler(container, config);
            dealLogin(config);

            // 个人名片浮层
            hoverShow(container.find('.top-nav-container .J-user-trigger'), container.find('.J-user-target'));
            // 个人名片点击打点
            lxWrap($('.J-user-target a'), lxBid.userInforBid, true, false)
            lxWrap($('.userinfo-container .username'), lxBid.userInforBid, true, false)
        }
        // 未登录点击
        lxWrap($('.J-login-container a'), lxBid.loginBid, true, false)
        // 个人中心浮层
        hoverShow(container.find('.J-my-center-trigger'), container.find('.J-my-center-target'));

        // 个人中心打点
        lxWrap($('.J-my-center-target a'), lxBid.userCenterBid, true, false)

        // 商户服务浮层
        hoverShow(container.find('.J-shop-serve-trigger'), container.find('.J-shop-serve-target'));

        // 帮助中心浮层
        hoverShow(container.find('.J-help-trigger'), container.find('.J-help-target'));

        // 网站导航浮层
        hoverShow(container.find('.J-site-trigger'), container.find('.J-site-target'), null, 'right');
    }
}



// WEBPACK FOOTER //
// ./modules/top-nav/js/top-nav.js